import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Participante, ProcesoFirma } from '../../interfaces/datos-firma-interface';
import { FirmaDigitalService } from '../../services/firma-digital.service';
import { CognitoService } from '../../services/cognito.service';
import { ValidadoresService } from '../../services/validadores.service';

@Component({
  selector: 'app-bandeja-principal',
  templateUrl: './bandeja-principal.component.html',
  styleUrls: ['./bandeja-principal.component.css']
})
export class BandejaPrincipalComponent implements OnInit {

  columnas: number = 6;
  colspanDocto: number = 4;
  colspanFirmantes: number = 2;
  procesoFirma: ProcesoFirma;
  firmantes: Participante[] = [];
  id: string;
  rut: string;
  errorRuta: boolean = false;
  
  constructor(private firmaService: FirmaDigitalService, private activatedRoute: ActivatedRoute, private validarServices: ValidadoresService,
    private autenticacionServices: AutenticacionService, private cognitoServices: CognitoService, private router: Router) {}

  ngOnInit(): void {
    this.columnas = (window.innerWidth <= 980) ? 1 : 6;
    this.colspanDocto = (window.innerWidth <= 980) ? 1 : 4;
    this.colspanFirmantes = (window.innerWidth <= 980) ? 1 : 2;

    this.activatedRoute.params.subscribe(params => {
      if (params['id'] !== undefined && params['rut'] !== undefined) {
        this.id = params['id'];
        this.rut = params['rut'];
        this.ingresar();
      } else {
        this.errorRuta = true;
        console.log('Error de acceso al sitio');
      }
    }); 
  }

  onResize(event: any) {
    this.columnas = (event.target.innerWidth <= 980) ? 1 : 6;
    this.colspanDocto = (event.target.innerWidth <= 980) ? 1 : 4;
    this.colspanFirmantes = (event.target.innerWidth <= 980) ? 1 : 2;
  }

  ingresar() {
  if (!this.autenticacionServices.estaAutenticado()) {
    this.cognitoServices.getToken().subscribe(response => {
      if (response.access_token !== '') {
        this.autenticacionServices.ingresarToken(response.access_token);
      }
      this.cargarDatos(this.id, this.rut);        
      });  
    } else {
      this.cargarDatos(this.id, this.rut);
    }
  }

  cargarDatos(id: string, rut: string) {
    this.firmaService.obtenerDocumentoPorIdentificador(id).subscribe(response => {
      // Valores documento
      this.procesoFirma = response;

      let estado = this.validarServices.validarEstadoDocumentoParticipante(this.procesoFirma, atob(rut)); 
      if (estado === 'pendiente') {
        // Valores para los firmantes
        var datosBase = response.participantesProcesoFirma;
        datosBase.forEach((item) => {
          if (atob(rut) === item.rut && item.estatus === 'PENDING') {
            item.style = 'habilitado';
          } else {
            item.style = 'deshabilitado';
          }        
        });

        this.firmantes = datosBase;
      } else {
        this.redireccion(estado);        
      }
    }, err => {
      console.log(err.message);
    });
  }

  redireccion(estado: string) {
    switch(estado) {
      case 'cancelado':
        this.router.navigate(['/resultado', 3]);
        break;
      case 'inexistente':
        this.router.navigate(['/resultado', 4]);
        break;
      case 'firmado':
        this.router.navigate(['/resultado', 5]);
        break;
    }    
  }
}
